import { cx } from '@emotion/css';
import { PropsWithChildren, useRef } from 'react';
import { MsgListItemProps } from './types';
import { useContextMenu } from 'react-contexify';
import { contextMenuId } from 'views/Conversation/Chat/components/MessageMenu/ContextMenu';

interface MsgListItemWrapperProps
  extends Pick<MsgListItemProps, 'message' | 'highlightMsg' | 'getRef'> {
  className?: string;
  onClick?: () => void;
}

export const MsgListItemWrapper = (props: PropsWithChildren<MsgListItemWrapperProps>) => {
  const { children, message, highlightMsg, getRef, className, onClick } = props;
  const ref = useRef<HTMLDivElement>();

  const { msgId: currentMsgId } = message;

  const highlightClassName = highlightMsg?.[currentMsgId];

  const { hideAll } = useContextMenu({
    id: contextMenuId,
  });

  return (
    <div
      className={cx('relative p-2 flex items-center', className, highlightClassName)}
      ref={(div) => {
        ref.current = div || undefined;
        getRef?.(ref);
      }}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
        hideAll();
      }}
    >
      {children}
    </div>
  );
};
